import axios from "axios";

export let instance = axios.create();
